export enum ONBOARDING {
  BACK_BUTTON = "onboardingBackButton",
  WELCOME_NEXT_BUTTON = "onboardingWelcomeStepNextButton",
  FIRST_STEP_NEXT_BUTTON = "onboardingFirstStepNextButton",
  SECOND_STEP_SUBMIT_BUTTON = "onboardingSecondStepSubmitButton",
  STEP_COUNTER = "onboardingStepCounter",

  FORM = "onboardingForm",
  HOME_STYLE = "onboardingFormHomeStyle",
  SIZE = "onboardingFormSize",
  BEDROOMS = "onboardingFormBedrooms",
  BATHROMS = "onboardingFormBathrooms",
  ADULTS = "onboardingFormAdults",
  CHILDREN = "onboardingFormChildren",
  PERSONALITY = "onboardingFormPersonality",
  PERSONALITY_TIP = "onboardingPersonalityTip",
}

export enum CHECKLIST_FORM {
  SAVE_BUTTON = "checklistFormSaveButton",
  EXIT_BUTTON = "checklistFormExitButton",
  FORM = "checklistForm",
  FORM_CLEANING_MATERIALS = "checklistCleaningMaterials",
  PREV_SECTION = "checklistFormPrevSection",
  NEXT_SECTION = "checklistFormNextSection",
  CHECKLIST_EXPLANATION_MODAL = "checklistExplanationModal",
  OPEN_CHECKLIST_EXPLANATION = "openChecklistExplanation",
  STEP_COUNTER = "checklistFormStepCounter",
}

export enum THANK_YOU {
  CLOSE_BUTTON = "thankYouCloseButton",
}

export enum CLEANING_CHECKLIST_WARNING {
  CANCEL_BUTTON = "cleaningChecklistWarningCancelButton",
  GOT_IT_BUTTON = "cleaningChecklistWarningGotItButton",
  MODAL = "cleaningChecklistWarningModal",
}
